var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8HandCursor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,2c-1.105,0 -2,0.895 -2,2v8v1v6.5c-2.552,-1.299 -3.711,-1.5 -5,-1.5c-1.49609,0 -2.99026,0.57731 -2.99805,2.48633l4.49805,2.01367l3.15625,3.15625c1.5,1.5 3.5362,2.34375 5.6582,2.34375h6.68555c2.209,0 4,-1.791 4,-4v-10c0,-1.10457 -0.89543,-2 -2,-2c-0.77365,0.00117 -1.47724,0.44842 -1.80664,1.14844c-0.12655,-0.0862 -0.19336,-0.14844 -0.19336,-0.14844c0,-1.10457 -0.89543,-2 -2,-2c-1.10457,0 -2,0.89543 -2,2v-1c0,-1.105 -0.895,-2 -2,-2c-1.105,0 -2,0.895 -2,2v-8c0,-1.105 -0.895,-2 -2,-2zM1.00195,20.48633h-0.00195v0.01367c0,-0.00501 0.00193,-0.00868 0.00195,-0.01367z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HandCursor);
export default __webpack_public_path__ + "static/media/icons8-hand-cursor.34894622de9106583bda3aac491285e7.svg";
export { ForwardRef as ReactComponent };